// Slick JS
import 'slick-carousel/slick/slick.min';

if( $('html').attr('dir') === 'rtl' || $('body').hasClass('rtl') ) {
  //-------------------------- Arabic
  // Small news VERTICAL slider (LARGE SCREENS) HORIZONTAL (SMALL SCREENS)
  $('#small-news-events-slider').slick({
    dots: false,
    slidesToScroll: 1,
    slidesToShow: 3,
    arrows: true,
    infinite: false,
    centerMode: true,
    useTransform: false,
    useCss: false,
    swipeToSlide: true,
    // adaptiveHeight: true,
    vertical: true,
    verticalSwiping: true,
    rtl: false,
    responsive: [{
        breakpoint: 1199,
        settings: {
          dots: true,
          arrows: true,
          slidesToShow: 1,
          slidesToScroll: 1,
          vertical: false,
          verticalSwiping: false,
          rtl: true,
        }
      },
      {
        breakpoint: 991,
        settings: {
          dots: true,
          arrows: true,
          slidesToShow: 1,
          slidesToScroll: 1,
          vertical: false,
          verticalSwiping: false,
          rtl: true,
        }
      },
      {
        breakpoint: 768,
        settings: {
          dots: true,
          arrows: true,
          slidesToShow: 1,
          slidesToScroll: 1,
          vertical: false,
          verticalSwiping: false,
          rtl: true,
        }
      },
      {
        breakpoint: 576,
        settings: {
          dots: true,
          arrows: true,
          slidesToShow: 1,
          slidesToScroll: 1,
          vertical: false,
          verticalSwiping: false,
          rtl: true,
        }
      },
    ]
  });
  // Slider 1
  $('#professionals-slider').slick({
    dots: true,
    slidesToScroll: 1,
    slidesToShow: 3,
    arrows: true,
    infinite: false,
    centerMode: false,
    useTransform: false,
    useCss: false,
    swipeToSlide: true,
    adaptiveHeight: true,
    rtl: true,
    responsive: [{

        breakpoint: 1199,
        settings: {
          arrows: true,
          slidesToShow: 3,
          slidesToScroll: 3,
        }
      },
      {
        breakpoint: 991,
        settings: {
          arrows: true,
          slidesToShow: 2,
          slidesToScroll: 2,
        }
      },
      {
        breakpoint: 768,
        settings: {
          arrows: true,
          slidesToShow: 2,
          slidesToScroll: 2,
        }
      },
      {
        breakpoint: 576,
        settings: {
          arrows: false,
          slidesToShow: 1,
          slidesToScroll: 1,
        }
      },
    ]
  });
  // Slider 2
  $('#professionals-slider2').slick({
    dots: true,
    slidesToScroll: 1,
    slidesToShow: 4,
    arrows: true,
    infinite: false,
    centerMode: false,
    useTransform: false,
    useCss: false,
    swipeToSlide: true,
    adaptiveHeight: true,
    rtl: true,
    responsive: [{

        breakpoint: 1199,
        settings: {
          arrows: true,
          slidesToShow: 3,
          slidesToScroll: 3,
        }
      },
      {
        breakpoint: 991,
        settings: {
          arrows: true,
          slidesToShow: 2,
          slidesToScroll: 2,
        }
      },
      {
        breakpoint: 768,
        settings: {
          arrows: true,
          slidesToShow: 2,
          slidesToScroll: 2,
        }
      },
      {
        breakpoint: 576,
        settings: {
          arrows: false,
          slidesToShow: 1,
          slidesToScroll: 1,
        }
      },
    ]
  });
}else{
  // English version
  // Small news VERTICAL slider (LARGE SCREENS) HORIZONTAL (SMALL SCREENS)
  $('#small-news-events-slider').slick({
    dots: false,
    slidesToScroll: 1,
    slidesToShow: 3,
    arrows: true,
    infinite: false,
    centerMode: false,
    useTransform: false,
    useCss: false,
    swipeToSlide: true,
    adaptiveHeight: true,
    vertical: true,
    verticalSwiping: true,
    responsive: [{
        breakpoint: 1199,
        settings: {
          dots: true,
          arrows: true,
          slidesToShow: 1,
          slidesToScroll: 1,
          vertical: false,
          verticalSwiping: false,
        }
      },
      {
        breakpoint: 991,
        settings: {
          dots: true,
          arrows: true,
          slidesToShow: 1,
          slidesToScroll: 1,
          vertical: false,
          verticalSwiping: false,
        }
      },
      {
        breakpoint: 768,
        settings: {
          dots: true,
          arrows: true,
          slidesToShow: 1,
          slidesToScroll: 1,
          vertical: false,
          verticalSwiping: false,
        }
      },
      {
        breakpoint: 576,
        settings: {
          dots: true,
          arrows: true,
          slidesToShow: 1,
          slidesToScroll: 1,
          vertical: false,
          verticalSwiping: false,
        }
      },
    ]
  });
  // Slider 1
  $('#professionals-slider').slick({
    dots: true,
    slidesToScroll: 1,
    slidesToShow: 3,
    arrows: true,
    infinite: false,
    centerMode: false,
    useTransform: false,
    useCss: false,
    swipeToSlide: true,
    adaptiveHeight: true,
    responsive: [{

        breakpoint: 1199,
        settings: {
          arrows: true,
          slidesToShow: 3,
          slidesToScroll: 3,
        }
      },
      {
        breakpoint: 991,
        settings: {
          arrows: true,
          slidesToShow: 2,
          slidesToScroll: 2,
        }
      },
      {
        breakpoint: 768,
        settings: {
          arrows: true,
          slidesToShow: 2,
          slidesToScroll: 2,
        }
      },
      {
        breakpoint: 576,
        settings: {
          arrows: false,
          slidesToShow: 1,
          slidesToScroll: 1,
        }
      },
    ]
  });

  // Slider 2
  $('#professionals-slider2').slick({
    dots: true,
    slidesToScroll: 1,
    slidesToShow: 4,
    arrows: true,
    infinite: false,
    centerMode: false,
    useTransform: false,
    useCss: false,
    swipeToSlide: true,
    adaptiveHeight: true,
    responsive: [{

        breakpoint: 1199,
        settings: {
          arrows: true,
          slidesToShow: 3,
          slidesToScroll: 3,
        }
      },
      {
        breakpoint: 991,
        settings: {
          arrows: true,
          slidesToShow: 2,
          slidesToScroll: 2,
        }
      },
      {
        breakpoint: 768,
        settings: {
          arrows: true,
          slidesToShow: 2,
          slidesToScroll: 2,
        }
      },
      {
        breakpoint: 576,
        settings: {
          arrows: false,
          slidesToShow: 1,
          slidesToScroll: 1,
        }
      },
    ]
  });
}

